import { Card, CardBody, Col, Row } from "reactstrap";
import { completeCourseData } from "../../../../Data/Widgets/GeneralWidgetsData";
import { H4, SVG } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import CommonSquare from "./CommonSquare/CommonSquare";

const CompletedCourses = () => {
  return (
    <Col xxl="3" xl="4" md="6" className="box-col-6">
      <Row>
        {completeCourseData.map((data,i)=>(
          <Col sm="12" key={i}>
            <Card className="course-box widget-course">
              <CardBody>
                <div className="course-widget">
                  <div className={`course-icon ${data.class}`}>
                    <SVG className="fill-icon" iconId={data.svg1}/>
                  </div>
                  <div>
                    <H4 className="mb-0">{data.count}</H4>
                    <span className="f-light">{data.header}</span>
                    <Link className="btn btn-light f-light" to={`${process.env.PUBLIC_URL}/learning/learninglist`} >
                      {data.btn}
                      <span className="ms-2">
                        <SVG className="fill-icon f-light" iconId={data.svg2} />
                      </span>
                    </Link>
                  </div>
                </div>
              </CardBody>
              <CommonSquare />
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default CompletedCourses;
